import { call } from 'redux-saga/effects';
import axios from 'axios';

const Api = {
  getOrder: orderReference =>
    axios.get(`/api/order/byReference/${orderReference}?identity=client`)
};

function* findOrder({ payload: { params, onStart, onSuccess, onError } }) {
  onStart && onStart();
  try {
    const { status, data } = yield call(Api.getOrder, params.orderReference);
    if (status === 200) {
      onSuccess && onSuccess(data);
    }
  } catch (error) {
    if (error.request.status === 404) {
      onSuccess && onSuccess({ order: null });
    } else {
      onError && onError(error);
    }
  }
}

export default findOrder;